import { isEmpty } from 'lodash';

import { SelectInputOption } from '@/components/form/baseInputs/inputTypes';
import { GetEntityDetails_Entity_DocumentFragment } from '@/modules/entities/components/EntityNotesPerDeath/graphql/GetHouseholdDocuments.generated';

export const mapDocumentToOption = (
  document: GetEntityDetails_Entity_DocumentFragment
): SelectInputOption<string>[] => {
  if (isEmpty(document.summaries)) {
    return [
      {
        display: document.name,
        value: document.id,
        disabled: true,
        endAdornment: 'Summarizing',
      },
    ];
  }
  return (
    document.summaries?.map((summary) => {
      return {
        display: document.name,
        secondaryText: summary.displayName,
        value: summary.id,
      };
    }) ?? []
  );
};
